var render, staticRenderFns
import script from "./erDateTable.vue?vue&type=script&lang=js&"
export * from "./erDateTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f83cce",
  null
  
)

export default component.exports